<script lang="ts" setup>
import { ref, onMounted } from "vue";
import Constants from "@/Constants";
const props = defineProps<{
  showInfo?: boolean;
  showDark?: boolean;
  tooltipMounted?: string;
  showPrint?: boolean;
}>();

const emit = defineEmits(["refresh", "info", "print"]);
const showPrint = ref<boolean>(false);

onMounted(() => {
  showPrint.value = props.showPrint;
  if (Constants.isMobile) {
    showPrint.value = false;
  }
});
</script>
<template>
  <v-tooltip
    :disabled="!props.tooltipMounted"
    location="bottom"
    :text="props.tooltipMounted"
  >
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        @click="emit('refresh')"
        variant="text"
        class="pa-0"
        prepend-icon="mdi-refresh"
        density="compact"
      >
        <!-- <v-icon v-if="props.showDark" dark> mdi-refresh </v-icon>
        <v-icon v-if="!props.showDark" color="grey"> mdi-refresh </v-icon> -->
      </v-btn>
    </template>
  </v-tooltip>
  <v-btn
    v-if="props.showInfo"
    @click="emit('info')"
    variant="text"
    prepend-icon="mdi-information-outline"
    density="compact"
    class="pa-0"
  >
    <!-- <v-icon v-if="props.showDark" dark> mdi-information-outline </v-icon>
    <v-icon v-if="!props.showDark" color="grey"> mdi-information-outline </v-icon> -->
  </v-btn>
  <v-btn v-if="showPrint" @click="emit('print')" variant="text" size="small">
    <v-icon v-if="props.showDark" dark> mdi-printer </v-icon>
    <v-icon v-if="!props.showDark" color="grey"> mdi-printer </v-icon>
  </v-btn>
</template>
